<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2f">A MAP OF SMIRISARY</h2>
<div class="page-break">
<p class="imagea"><a id="pviii"></a><span epub:type="pagebreak" id="pageviii" title="viii"><img alt="Illustration" src="images/fviii-01.png"/></span></p>
<div class="page-break">
<p class="imagea"><a id="pix"></a><span epub:type="pagebreak" id="pageix" title="ix"><img alt="Illustration" src="images/f00ix-01.png"/><a id="px"></a><span epub:type="pagebreak" id="pagex" title="x"></span></span></p>
</div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm02.vue?e6efccf8